import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './WheelOfFortune.css';
import { useTokens } from '../components/TokenContext';

const segments = [
    { label: 'x0', multiplier: 0 },
    { label: 'x2', multiplier: 2 },
    { label: 'x5', multiplier: 5 },
    { label: 'x10', multiplier: 10 },
    { label: 'x3', multiplier: 3 },
    { label: 'x0', multiplier: 0 },
    { label: 'x4', multiplier: 4 },
    { label: 'x0', multiplier: 0 },
];

function WheelOfFortune() {
    const { fetchTokens } = useTokens();
    const [isSpinning, setIsSpinning] = useState(false);
    const [rotationAngle, setRotationAngle] = useState(0);
    const [betAmount, setBetAmount] = useState('');

    const handleSpin = async () => {
        if (!betAmount || betAmount <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        setIsSpinning(true);

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/wheel.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    betAmount: betAmount
                })
            });

            const data = await response.json();

            if (data.error) {
                setIsSpinning(false);
                Swal.fire('Chyba', data.error, 'error');
                return;
            }

            const winningIndex = segments.findIndex(segment => segment.multiplier === data.multiplier);

            // Oprava výpočtu pro přesné zarovnání na šipku
            const segmentAngle = 360 / segments.length;
            const offset = segmentAngle / 2; // Posun na střed segmentu
            const randomAngle = 360 * 5 + (winningIndex * segmentAngle) + offset;

            setRotationAngle(randomAngle);

            setTimeout(() => {
                setIsSpinning(false);

                if (data.multiplier > 0) {
                    Swal.fire('Výhra!', `Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} tokenů! 🎉`, 'success');
                } else {
                    Swal.fire('Prohra', 'Bohužel jsi nevyhrál, zkus to znovu! 😢', 'error');
                }

                fetchTokens();
            }, 4000);

        } catch (error) {
            setIsSpinning(false);
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-wheel">
            <h1>Kolo štěstí 🎡</h1>

            <div className="wheel-container">
                <div
                    className={`wheel ${isSpinning ? 'spinning' : ''}`}
                    style={{ transform: `rotate(${rotationAngle}deg)` }}
                >
                    {segments.map((segment, index) => (
                        <div
                            key={index}
                            className="segment"
                            style={{
                                transform: `rotate(${index * (360 / segments.length)}deg)`
                            }}
                        >
                            {segment.label}
                        </div>
                    ))}
                </div>

                <div className="pointer">▼</div>
            </div>

            <div className="input-container">
                <input
                    type="number"
                    min="1"
                    value={betAmount}
                    onChange={(e) => setBetAmount(e.target.value)}
                    placeholder="Zadej sázku"
                />
                <button className="btn btn-warning" onClick={handleSpin} disabled={isSpinning}>
                    {isSpinning ? 'Točí se...' : 'Roztočit kolo'}
                </button>
            </div>
        </div>
    );
}

export default WheelOfFortune;
